/**
 * @generated SignedSource<<757eafa7e4ef3b8fc5e26bfbe4283170>>
 * @relayHash 1d53dc2f7314c80ba663b467e852ec84
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b5dcb746fda136e84a884ac06831341504198387937fc6b01a81f36ee305b438

import type { ConcreteRequest, Query } from 'relay-runtime';
export type src_EndOfTrialMessageSharedGlobalComponentQuery$variables = {
  cloudId: string;
  hamsProductKey: string;
};
export type src_EndOfTrialMessageSharedGlobalComponentQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly offering: {
          readonly trial?: {
            readonly lengthDays: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly preDunning: {
          readonly firstPreDunningEndTimestampV2: number | null | undefined;
        } | null | undefined;
        readonly subscription: {
          readonly accountDetails: {
            readonly invoiceGroup: {
              readonly invoiceable: boolean | null | undefined;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type src_EndOfTrialMessageSharedGlobalComponentQuery = {
  response: src_EndOfTrialMessageSharedGlobalComponentQuery$data;
  variables: src_EndOfTrialMessageSharedGlobalComponentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hamsProductKey"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "hamsProductKey"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "AND": [
        {
          "inPreDunning": true
        }
      ]
    }
  }
],
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "CcpOfferingTrial",
      "kind": "LinkedField",
      "name": "trial",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "lengthDays"
        }
      ]
    }
  ],
  "type": "CcpOffering"
},
v5 = {
  "kind": "ScalarField",
  "name": "firstPreDunningEndTimestampV2"
},
v6 = {
  "kind": "ScalarField",
  "name": "invoiceable"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = [
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "src_EndOfTrialMessageSharedGlobalComponentQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "offering",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "preDunning",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "subscription",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "accountDetails",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "invoiceGroup",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "entitlement(where:{\"AND\":[{\"inPreDunning\":true}]})"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "src_EndOfTrialMessageSharedGlobalComponentQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "offering",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v9/*: any*/),
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "preDunning",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v5/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "subscription",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "accountDetails",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "invoiceGroup",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v6/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v9/*: any*/),
                                "type": "CcpInvoiceGroup"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v9/*: any*/),
                        "type": "CcpSubscription"
                      }
                    ]
                  },
                  (v8/*: any*/)
                ],
                "storageKey": "entitlement(where:{\"AND\":[{\"inPreDunning\":true}]})"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b5dcb746fda136e84a884ac06831341504198387937fc6b01a81f36ee305b438",
    "metadata": {},
    "name": "src_EndOfTrialMessageSharedGlobalComponentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ecb414629484f8d10335358818e21bd3";

export default node;
